var _a;
import React from "react";
import { ComparisonReferences } from "../interfaces/store/actions/payload/schema/schemaElements";
import process from "process";
import { validateFieldReferences } from "..";
import { VALIDATION_TRANSLATE_PATH } from "./constants";
var formatStringRegex = /{(\d+)}/g;
var urlRegex = new RegExp("https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)", "ig");
var checkTranslation = function (id, fallback, translate) {
    var translation = translate(id);
    return translation.startsWith('_error_') || translation.startsWith("Missing") ? fallback : translation;
};
var formatString = function (template) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return template.replace(formatStringRegex, function (test, index) { return (typeof values[index] !== "undefined" ? values[index] : test); });
};
var validateOptionalNumericField = function (_a) {
    var optional = _a.optional, value = _a.value, optionalFallbackTranslation = _a.optionalFallbackTranslation, fieldTranslatePath = _a.fieldTranslatePath, translate = _a.translate;
    var error;
    if (optional === false) {
        var fallbackTranslation = translate(optionalFallbackTranslation);
        var translationId = fieldTranslatePath + ".optional.text";
        var val = typeof value === "number" && !Number.isNaN(value);
        if (!val) {
            error = checkTranslation(translationId, fallbackTranslation, translate);
        }
    }
    return error;
};
var validateLiteralPrimitiveField = function (_a) {
    var value = _a.value, literalValue = _a.literalValue, literalFallbackTranslation = _a.literalFallbackTranslation, fieldTranslatePath = _a.fieldTranslatePath, translate = _a.translate;
    var error;
    if (literalValue !== value) {
        var fallbackTranslation = translate(literalFallbackTranslation);
        var translationId = fieldTranslatePath + ".literal.text";
        error = checkTranslation(translationId, fallbackTranslation, translate);
    }
    return error;
};
var isGeometryPoint = function (value) {
    return Array.isArray(value) && value.length === 2 && !Number.isNaN(value[0]) && !Number.isNaN(value[1]);
};
var validateOptionalGeometryField = function (_a) {
    var optional = _a.optional, value = _a.value, optionalFallbackTranslation = _a.optionalFallbackTranslation, fieldTranslatePath = _a.fieldTranslatePath, translate = _a.translate;
    var error;
    if (optional === false) {
        var isArray = Array.isArray(value);
        var invalidPoints = isArray && !!value.filter(function (point) { return !isGeometryPoint(point); }).length;
        if (invalidPoints) {
            var fallbackTranslation = translate(optionalFallbackTranslation);
            var translationId = fieldTranslatePath + ".optional.text";
            error = checkTranslation(translationId, fallbackTranslation, translate);
        }
    }
    return error;
};
var validateLiteralGeometryField = function (_a) {
    var value = _a.value, literalValue = _a.literalValue, literalFallbackTranslation = _a.literalFallbackTranslation, fieldTranslatePath = _a.fieldTranslatePath, translate = _a.translate;
    var error;
    var sameLength = literalValue.length === value.length;
    var literalIsEqual = sameLength && !literalValue.filter(function (literalItem, index) {
        return literalItem[0] !== value[index][0]
            && literalItem[1] !== value[index][1];
    }).length;
    if (!literalIsEqual) {
        var fallbackTranslation = translate(literalFallbackTranslation);
        var translationId = fieldTranslatePath + ".literal.text";
        error = checkTranslation(translationId, fallbackTranslation, translate);
    }
    return error;
};
var isFieldEmpty = function (value, multiValue, translationId, fallbackTranslation, translate) {
    var error = null;
    var val;
    if (value && multiValue) {
        val = Array.isArray(value) && value.length
            ? value.map(function (item) { return item.trim() === ""; }) : null;
    }
    else {
        val = value ? !(value.trim() === "") : null;
    }
    if (!val) {
        error = checkTranslation(translationId, fallbackTranslation, translate);
    }
    return error;
};
var isVisibleConditionalField = function (conditionalFieldInfo) {
    var fieldName = conditionalFieldInfo.fieldName, whenReference = conditionalFieldInfo.whenReference, anyOfValues = conditionalFieldInfo.anyOfValues, value = conditionalFieldInfo.value, refElements = conditionalFieldInfo.element.refElements;
    var isVisible = false;
    var conditionalElement = refElements ? refElements[whenReference] : null;
    var fieldValue = (fieldName && value[fieldName]) ? value[fieldName] : value[whenReference];
    if (conditionalElement && fieldValue !== undefined && fieldValue !== null) {
        isVisible = (Array.isArray(fieldValue)
            && fieldValue.some(function (el) { return anyOfValues.includes(el); }))
            || anyOfValues.includes(fieldValue);
    }
    return isVisible;
};
var paramsSerializer = function (params) {
    var options = "";
    for (var key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            var obj = params[key];
            if (typeof obj !== "object" && obj !== undefined) {
                options += key + "=" + encodeURIComponent(obj) + "&";
            }
            else if (typeof obj === "object" && obj && obj.length) {
                var counter = 0;
                while (counter < obj.length) {
                    options += key + "=" + encodeURIComponent(params[key][counter]) + "&";
                    counter += 1;
                }
            }
        }
    }
    return options ? options.slice(0, -1) : options;
};
var queryEncoder = function (param) {
    var parameterKeyValuePair = param.split("=");
    parameterKeyValuePair[1] = encodeURIComponent(parameterKeyValuePair[1]);
    return parameterKeyValuePair.join("=");
};
var isDevelopmentMode = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
var handleBackendValidation = function (frontendValid, backendValid) {
    if (typeof backendValid !== "undefined") {
        if (frontendValid !== backendValid && isDevelopmentMode) {
            console.warn("Elements validation problem! BE: " + backendValid + ", FE: " + frontendValid);
        }
    }
};
var parseTextUrls = function (text) {
    var textContent = [];
    if (text) {
        var urlsFound = text.match(urlRegex);
        if (urlsFound && urlsFound.length > 0) {
            urlsFound.forEach(function (url, index) {
                var urlIndices = getAllIndices(text, url);
                urlIndices.forEach(function (urlIndex, appearance) {
                    textContent.push(text.substring(0, urlIndex));
                    textContent.push(React.createElement("a", { key: url + "-" + index + "-" + appearance, href: url, target: "_blank", rel: "noopener noreferrer" }, url));
                    textContent.push(text.substring(urlIndex + url.length));
                });
            });
        }
        else {
            textContent.push(text);
        }
    }
    return textContent;
};
var getAllIndices = function (text, value) {
    var indices = [];
    var startIndex = 0;
    var index = text.indexOf(value, startIndex);
    while (index > -1) {
        indices.push(index);
        startIndex = index + value.length;
        index = text.indexOf(value, startIndex);
    }
    return indices;
};
var getFormErrors = function (elementsValues, element, references, schemaKey, translate, segmentId) {
    var allErrors = [];
    references.forEach(function (spanRef) {
        var errors = validateFieldReferences(elementsValues, element.refElements[spanRef], translate, segmentId);
        if (errors.length) {
            allErrors = allErrors.concat(errors);
        }
    });
    return allErrors;
};
var comparisonErrorsKeys = (_a = {},
    _a[ComparisonReferences.EQ] = "_eqError",
    _a[ComparisonReferences.GT] = "_gtError",
    _a[ComparisonReferences.GTE] = "_gteError",
    _a[ComparisonReferences.LT] = "_ltError",
    _a[ComparisonReferences.LTE] = "_lteError",
    _a);
var simpleValueComparator = function (fieldValue, referenceValue, comparisonReference) {
    var isValid = false;
    switch (comparisonReference) {
        case ComparisonReferences.EQ:
            isValid = fieldValue === referenceValue;
            break;
        case ComparisonReferences.GT:
            isValid = fieldValue > referenceValue;
            break;
        case ComparisonReferences.GTE:
            isValid = fieldValue >= referenceValue;
            break;
        case ComparisonReferences.LT:
            isValid = fieldValue < referenceValue;
            break;
        case ComparisonReferences.LTE:
            isValid = fieldValue <= referenceValue;
            break;
        default:
            break;
    }
    return isValid;
};
var arrayComparator = function (fieldValue, referenceValue, comparisonReferences) {
    var comparisonArray;
    var comparisonItem;
    if (Array.isArray(fieldValue)) {
        comparisonArray = fieldValue;
        comparisonItem = referenceValue;
    }
    else {
        comparisonArray = referenceValue;
        comparisonItem = fieldValue;
    }
    var allMembersValid = comparisonArray.map(function (member) {
        return simpleValueComparator(member, comparisonItem, comparisonReferences);
    });
    return (ComparisonReferences.EQ === comparisonReferences
        ? allMembersValid.some(function (value) { return value; })
        : allMembersValid.findIndex(function (valid) { return !valid; }) === -1);
};
var complexValueComparator = function (fieldValue, referenceValue, comparisonReference) {
    var comparisonArray;
    var comparisonItem;
    if (Array.isArray(fieldValue)) {
        comparisonArray = fieldValue;
        comparisonItem = referenceValue;
    }
    else {
        comparisonArray = referenceValue;
        comparisonItem = fieldValue;
    }
    var allMembersValid = comparisonArray.map(function (member) {
        return arrayComparator(member, comparisonItem, comparisonReference);
    });
    return (allMembersValid.findIndex(function (isValid) { return !isValid; }) === -1);
};
var referenceComparator = function (fieldValue, referenceValue, comparisonReference) {
    var isValid;
    if (Array.isArray(fieldValue) || Array.isArray(referenceValue)) {
        var values = Array.isArray(fieldValue) ? fieldValue : referenceValue;
        var numberOfValueArrays = values.filter(Array.isArray).length;
        if (numberOfValueArrays === values.length) {
            isValid = complexValueComparator(fieldValue, referenceValue, comparisonReference);
        }
        else {
            isValid = arrayComparator(fieldValue, referenceValue, comparisonReference);
        }
    }
    else {
        isValid = simpleValueComparator(fieldValue, referenceValue, comparisonReference);
    }
    return isValid;
};
var validateComparisonItems = function (_a) {
    var value = _a.value, references = _a.references, comparisonReferences = _a.comparisonReferences, translate = _a.translate, fieldTranslatePath = _a.fieldTranslatePath;
    var error;
    var comparison = references.map(function (comparisonItem) {
        var isValid = true;
        if (value !== undefined && comparisonItem.value !== undefined) {
            isValid = referenceComparator(value, comparisonItem.value, comparisonReferences);
        }
        return isValid;
    });
    var validEqReferences = ComparisonReferences.EQ === comparisonReferences
        && comparison.some(function (isValid) { return isValid; });
    var errorIndex = comparison.findIndex(function (isValid) { return !isValid; });
    if (!validEqReferences && errorIndex > -1) {
        var fallbackKey = VALIDATION_TRANSLATE_PATH + "." + comparisonErrorsKeys[comparisonReferences] + ".text";
        var fallbackTranslation = translate(fallbackKey);
        var translationId = fieldTranslatePath + "." + comparisonErrorsKeys[comparisonReferences] + ".text";
        error = checkTranslation(translationId, fallbackTranslation, translate);
        error = formatString(error, references[errorIndex].value);
    }
    return error;
};
var validateComparisonConstraints = function (_a) {
    var value = _a.value, comparisonItems = _a.comparisonItems, fieldTranslatePath = _a.fieldTranslatePath, translate = _a.translate;
    var error;
    if (comparisonItems[ComparisonReferences.EQ]) {
        error = validateComparisonItems({
            value: value,
            references: comparisonItems[ComparisonReferences.EQ],
            comparisonReferences: ComparisonReferences.EQ,
            translate: translate,
            fieldTranslatePath: fieldTranslatePath,
        });
    }
    if (!error && comparisonItems[ComparisonReferences.GT]) {
        error = validateComparisonItems({
            value: value,
            references: comparisonItems[ComparisonReferences.GT],
            comparisonReferences: ComparisonReferences.GT,
            translate: translate,
            fieldTranslatePath: fieldTranslatePath,
        });
    }
    if (!error && comparisonItems[ComparisonReferences.GTE]) {
        error = validateComparisonItems({
            value: value,
            references: comparisonItems[ComparisonReferences.GTE],
            comparisonReferences: ComparisonReferences.GTE,
            translate: translate,
            fieldTranslatePath: fieldTranslatePath,
        });
    }
    if (!error && comparisonItems[ComparisonReferences.LT]) {
        error = validateComparisonItems({
            value: value,
            references: comparisonItems[ComparisonReferences.LT],
            comparisonReferences: ComparisonReferences.LT,
            translate: translate,
            fieldTranslatePath: fieldTranslatePath,
        });
    }
    if (!error && comparisonItems[ComparisonReferences.LTE]) {
        error = validateComparisonItems({
            value: value,
            references: comparisonItems[ComparisonReferences.LTE],
            comparisonReferences: ComparisonReferences.LTE,
            translate: translate,
            fieldTranslatePath: fieldTranslatePath,
        });
    }
    return error;
};
var isAccessDeniedError = function (error) {
    var _a = error.response, status = _a.status, data = _a.data;
    return status === 403 && data.code === "ACCESS_DENIED";
};
export { urlRegex, parseTextUrls, getAllIndices, checkTranslation, formatString, validateOptionalNumericField, validateLiteralPrimitiveField, isGeometryPoint, validateOptionalGeometryField, validateLiteralGeometryField, isFieldEmpty, isVisibleConditionalField, paramsSerializer, handleBackendValidation, getFormErrors, validateComparisonConstraints, isAccessDeniedError, queryEncoder, };
